import { render, staticRenderFns } from "./MilestonesView.vue?vue&type=template&id=2ee71283&"
import script from "./MilestonesView.vue?vue&type=script&lang=js&"
export * from "./MilestonesView.vue?vue&type=script&lang=js&"
import style0 from "./MilestonesView.vue?vue&type=style&index=0&id=2ee71283&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports